import { combineReducers } from 'redux-immutable';

import deviceType from './deviceType.duck';

export default combineReducers({
  deviceType
});
